export default "__VITE_ASSET__BYcys7Sa__"